module.exports = __webpack_public_path__ + "img/btn-btn-arrow-my-down-gray.cd33ba67.svg";